import SEO from "../components/SEO";
import seoData from "../seoData";
import BreadcrumbSchema from "../components/BreadcrumbSchema";
import { Services } from "../components/services";
import JsonData from "../data/data.json";

const ServicesPage = () => (
  <>
    {/* SEO Meta */}
    <SEO {...seoData.services} />
    <BreadcrumbSchema
        items={[
            { name: "Home", url: "/" },
            { name: "Services", url: "/services" },
        ]}
    />
    <Services data={JsonData.Services} />
  </>
);

export default ServicesPage;